import React, { MouseEvent, memo, MouseEventHandler, ComponentProps, ReactNode } from 'react'
import { Button } from 'transfix-ui/components/Button'
import Box from 'transfix-ui/core/Box'
import RadialSpinner from '../RadialSpinner'

export interface IModalAction {
  label: ReactNode
  disabled?: boolean
  loading?: boolean
  action?: () => any
  type: 'confirm' | 'dismiss' | 'delete'
  dataTest?: string
  ButtonProps?: ComponentProps<typeof Button>
  BoxProps?: ComponentProps<typeof Box>
}

interface IModalActionProps extends IModalAction {
  onClick: MouseEventHandler<HTMLButtonElement>
}

export const ModalAction = memo<IModalActionProps>(
  ({
    dataTest,
    disabled,
    label,
    onClick,
    type,
    ButtonProps = {},
    BoxProps = {},
    loading = false,
  }) => {
    const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      onClick(e)
    }

    if (loading) {
      return (
        <Box width={110} textAlign='center' {...BoxProps}>
          <RadialSpinner position='relative' size='small' />
        </Box>
      )
    }

    return (
      <Box display='inline-block' ml={1} {...BoxProps}>
        <Button
          disabled={disabled}
          color={type === 'confirm' ? 'primary' : 'tertiary'}
          value={type}
          onClick={handleButtonClick}
          size='large'
          className='mt0'
          data-test={dataTest}
          {...ButtonProps}>
          {label}
        </Button>
      </Box>
    )
  }
)
